import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as org from '../../organization'

export const RESOURCE = {
  payload: {
    description: 'Used to assess the organization joint use',
    dimension: org.RESOURCE.payload,
    name: 'Organization Joint Use',
    partialId: PartialId.Standard.create('org_joint_use'),
  },
  type: core.quiver.Resource.Type.DmsSnapshot,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsSnapshot>

export const MODEL_ID = core.dms.models.Snapshot.Id.from({
  context: core.dms.models.Snapshot.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
